// (ملف: src/WebhookSetupPage.js)
import React, { useState } from 'react';
import { db } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';

// 🔥 كومبوننت إعداد الـ Webhook لـ EasyOrder
function WebhookSetupPage({ user, clientData, setClientData }) {
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // 1. بناء رابط Webhook الخاص بـ EasyOrder (منفصل عن Shopify)
  // 🚨 UUID مختلف: d69cba6f-9626-48cf-a5a6-a2288ec32b5f
  const fullWebhookURL = `https://n8n2.dafaiagency.shop/webhook/d69cba6f-9626-48cf-a5a6-a2288ec32b5f/easy_order-hook-alsayes/${clientData.webhook_path_id}`;

  const handleSaveSecret = async (e) => {
    e.preventDefault();
    // 🔥 السيكرت اختياري - لو فاضي نحفظه كـ empty string
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 2. تحديث Document العميل في clients_v2
      const clientDocRef = doc(db, 'clients_v2', clientData.brand_name);
      
      // 3. حفظ الـ webhook secret (حتى لو فاضي)
      await updateDoc(clientDocRef, {
        ezy_webhook_secret: secret.trim() || '' // لو فاضي هيبقى empty string
      });

      // 4. تحديث الـ state المحلي
      setClientData(prevData => ({
        ...prevData,
        ezy_webhook_secret: secret.trim() || ''
      }));

      setSuccess('تم الحفظ بنجاح! يمكنك الآن استخدام لوحة التحكم.');
      
      // 🔥 تأخير بسيط ثم refresh الصفحة
      setTimeout(() => {
        window.location.reload();
      }, 1500);

    } catch (err) {
      console.error(err);
      setError('حدث خطأ أثناء الحفظ. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={setupStyles.container}>
      <div style={setupStyles.card}>
        <h2 style={{color: '#FF6B35', marginBottom: '10px'}}>🎉 مرحباً {clientData.brand_name}!</h2>
        <p style={{color: '#333', fontSize: '16px', marginBottom: '20px'}}>
          تم إنشاء حسابك بنجاح على منصة <strong>EasyOrder</strong>! 
          لتفعيل استقبال الطلبات عبر الواتساب، يرجى إتباع الخطوات التالية:
        </p>
        
        <ol style={setupStyles.list}>
          <li>اذهب إلى لوحة تحكم <strong>EasyOrder</strong>.</li>
          <li>اذهب إلى <span style={setupStyles.code}>Settings → Webhooks</span>.</li>
          <li>اضغط على <strong>"Add New Webhook"</strong>.</li>
          <li>في خانة <strong>"Event"</strong>، اختر <strong>"New Order"</strong>.</li>
          <li>في خانة <strong>"Webhook URL"</strong>، انسخ الرابط التالي:</li>
        </ol>

        <input 
          type="text" 
          readOnly 
          value={fullWebhookURL} 
          style={setupStyles.input} 
        />
        <button 
          onClick={() => {
            navigator.clipboard.writeText(fullWebhookURL);
            alert('تم نسخ الرابط!');
          }} 
          style={setupStyles.copyButton}
        >
          📋 نسخ الرابط
        </button>

        <div style={setupStyles.secretSection}>
          <p style={setupStyles.secretTitle}>🔐 الخطوة الأخيرة (اختيارية):</p>
          <p style={setupStyles.secretInstructions}>
            بعد حفظ الـ Webhook في EasyOrder، قد يظهر لك <strong>"Webhook Secret"</strong> أو <strong>"Signing Key"</strong>.<br/>
            📌 لو ظهرلك، انسخه والصقه في الخانة بالأسفل.
          </p>
          <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
            💡 <strong>ملاحظة مهمة:</strong> لو مفيش Webhook Secret في EasyOrder، اضغط مباشرة على <strong>"متابعة"</strong> 
            بدون إدخال أي شيء في الخانة.
          </p>
        </div>

        <form onSubmit={handleSaveSecret}>
          <input 
            type="text" 
            placeholder="EasyOrder Webhook Secret (اختياري - اتركه فارغاً إذا لم يكن موجوداً)"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            style={setupStyles.input}
          />
          <button type="submit" disabled={loading} style={setupStyles.saveButton}>
            {loading ? 'جاري الحفظ...' : '✅ متابعة إلى لوحة التحكم'}
          </button>
        </form>
        
        {error && <p style={{ color: 'red', marginTop: '10px', fontWeight: 'bold' }}>{error}</p>}
        {success && <p style={{ color: 'green', marginTop: '10px', fontWeight: 'bold' }}>{success}</p>}

        <div style={setupStyles.helpSection}>
          <p style={{fontSize: '14px', color: '#555'}}>
            ❓ <strong>محتاج مساعدة؟</strong> تواصل مع الدعم الفني.
          </p>
        </div>
      </div>
    </div>
  );
}

// 🎨 ستايلات الصفحة
const setupStyles = {
  container: {
    padding: '20px',
    background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)', // 🔥 لون مختلف عن Shopify
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
    padding: '40px',
    maxWidth: '750px',
    width: '100%',
    textAlign: 'right',
  },
  list: {
    textAlign: 'right',
    paddingRight: '20px',
    lineHeight: '1.9',
    color: '#333',
    fontSize: '15px',
    marginBottom: '25px',
  },
  code: {
    backgroundColor: '#fff3cd',
    padding: '3px 8px',
    borderRadius: '4px',
    fontFamily: 'monospace',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#856404',
  },
  input: {
    width: '100%',
    padding: '14px',
    margin: '12px 0',
    boxSizing: 'border-box',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    textAlign: 'left',
    fontFamily: 'monospace',
    backgroundColor: '#f9f9f9',
    transition: 'border 0.3s ease',
  },
  copyButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#f0f0f0',
    color: '#333',
    border: '2px solid #ccc',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '25px',
    transition: 'all 0.3s ease',
  },
  saveButton: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '17px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 12px rgba(40,167,69,0.3)',
  },
  secretSection: {
    marginTop: '30px',
    marginBottom: '25px',
    padding: '25px',
    backgroundColor: '#fff8e1',
    borderRight: '5px solid #FF6B35',
    borderRadius: '8px',
  },
  secretTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#FF6B35',
    marginBottom: '12px',
  },
  secretInstructions: {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#333',
    margin: 0,
  },
  helpSection: {
    marginTop: '30px',
    padding: '15px',
    backgroundColor: '#e3f2fd',
    borderRadius: '8px',
    textAlign: 'center',
  }
};

export default WebhookSetupPage;